import * as React from 'react'

import { useBloomreachPageRoutes } from '@grandvisionhq/bloomreach'
import { NextPage } from '@grandvisionhq/next'
import { Hooks } from '@grandvisionhq/stores-v2'
import { compose } from '@grandvisionhq/utils'
import { Page, Props } from '@grandvisionhq/www-next/pages/stores'

import { withCms, withLayout } from '../cms'

const StoresPage: NextPage<Props | undefined> = (props) => {
  const { routes } = useBloomreachPageRoutes()

  const { useDefaultStoreSearchFilters } = Hooks
  const { openNow, openOnTheWeekend, openOnSunday } = useDefaultStoreSearchFilters()
  const storeSearchFilters = React.useMemo(
    () => ({ openNow, openOnTheWeekend, openOnSunday }),
    [openNow, openOnTheWeekend, openOnSunday]
  )

  return (
    <Page
      {...props}
      bookAppointmentUrl={routes['book-appointment-form']}
      storeSearchFilters={storeSearchFilters}
    />
  )
}

StoresPage.getInitialProps = Page.getInitialProps

export default compose<Props, Props>(withCms(), withLayout())(StoresPage)
